import React from 'react';

import './charactersLimitComponent.css';

const CharactersLimitComponent = ({charactersLeft = 0}) => {
  return (
    <div className="et-n-input-field-characters-limit-container">
      {charactersLeft}
    </div>
  );
};

export default CharactersLimitComponent;
